import { render } from "./app-table.vue?vue&type=template&id=2e30e3e9&scoped=true"
import script from "./app-table.vue?vue&type=script&lang=js"
export * from "./app-table.vue?vue&type=script&lang=js"

import "./app-table.vue?vue&type=style&index=0&id=2e30e3e9&scoped=true&lang=css"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e30e3e9"]])

export default __exports__